import EventBus from '__jsEbentBus';
export default {
	data() {
		return {
			unKey: ''
		};
	},
	mounted() {
		window.onpopstate = (e) => {
			EventBus.$emit('onpopstate', e);
			window.location.reload();
			this.$store.commit('main/setHref', window.location.href);
		};
	},
	methods: {
		deepCopy(src) {
			let target = Array.isArray(src) ? [] : {};
			for (let key in src) {
				let v = src[key];
				if (v) {
					if (typeof v === 'object') {
						target[key] = this.deepCopy(v);
					}
					else {
						target[key] = v;
					}
				}
				else {
					target[key] = v;
				}
			}

			return target;
		},
		generateId(type) {
			var t = type + '-';
			return (
				t += (Math.random().toString(36).substr(2, 9))
			);
		},
		getParams(url) {
			var params = {};
			var parser = document.createElement('a');
			parser.href = url;
			var query = parser.search.substring(1);
			var vars = query.split('&');
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=');
				if (pair[0]) {
					params[pair[0]] = decodeURIComponent(pair[1]);
				}
			}
			return params;
		},
		changeParam(name, value) {
			let url = this.dynamichref;
			if (value == null) {
				value = '';
			}
			var pattern = new RegExp('\\b(' + name + '=).*?(&|#|$)');
			if (url.search(pattern) >= 0) {
				return url.replace(pattern, '$1' + value + '$2');
			}
			url = url.replace(/[?#]$/, '');
			url = url + (url.indexOf('?') > 0 ? '&' : '?') + name + '=' + value;
			return url;
		},
		getParamsUrl(params) {
			let paramsUrl = '';
			for (const key in params) {
				if (Object.hasOwnProperty.call(params, key)) {
					const element = params[key];
					paramsUrl += `&${key}=${element}`;
				}
			}
			if (!paramsUrl) {
				return '';
			}
			return `?${paramsUrl.substring(1)}`;
		}
	},
	filters: {
		formatPercentage(value) {
			return (Math.ceil(value * 100) / 100);
		},
		formatDate(value) {
			let date = new Date(value);
			const dayIOS = value.split('-')[2].split('T')[0];
			const hoursIOS = value.split('-')[2].split('T')[1].split(':')[0];
			const minutesIOS = value.split('-')[2].split('T')[1].split(':')[1];
			date.setHours(hoursIOS);
			date.setDate(dayIOS);
			date.setMinutes(minutesIOS);
			const monthNames = [
				'January', 'February', 'March', 'April', 'May', 'June',
				'July', 'August', 'September', 'October', 'November', 'December'
			];
			let hour = (date.getHours() > 12) ? (date.getHours() - 12) : (date.getHours());
			let minute = (date.getMinutes() < 10) ? (`0${date.getMinutes()}`) : (date.getMinutes());
			let ampm = (date.getHours() >= 12) ? ('PM') : ('AM');
			const year = date.getFullYear();
			const currentYear = new Date().getFullYear();
			const conditionalYear = currentYear > year ? `, ${year}` : '';
			return `${monthNames[date.getMonth()]} ${date.getDate()}${conditionalYear} at ${hour}:${minute} ${ampm}`;
		},
		formatComma(value) {
			return Number(value).toString().replace(/\./g, ',');
		},
		formatCOC: function(value) {
			let val = Number(value);
			return (Math.ceil(val * 100) / 100).toString().replace(/\./g, '.');
		},
		formatUp2: function(value) {
			let val = Number(value);
			// return (Math.ceil(val * 100) / 100).toString();
			return (Math.ceil(val * 100) / 100).toString().replace(/\./g, ',');
		},
		format2: function(value) {
			let val = Number(value);
			// return (Math.round(val * 100) / 100).toString();
			return (Math.round(val * 100) / 100).toString().replace(/\./g, ',');
		},
		formatPrice: function(value) {
			return Number(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			// return Number(value);
		},
	},
	computed: {
		dynamichref: {
			get() {
				return this.$store.state.main.href;
			},
			set(newVal) {
				this.$store.commit('main/routePush', {
					state: 'page',
					title: 'Title',
					url:   newVal,
				});
			}
		},
		paramsUrlObj() {
			return this.getParams(this.dynamichref);
		},
		paramsUrl() {
			return this.getParamsUrl(this.paramsUrlObj);
		},
	}
};
